import { ActionMap } from '@/components/forms/FormContext';
import { ReplaceVirtuallyFormState } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import userProfile from '@/helpers/userProfile';

export const ContactInfoStepActions = {
	UPDATE_FIRST_NAME: 'UPDATE_FIRST_NAME',
	UPDATE_LAST_NAME: 'UPDATE_LAST_NAME',
	UPDATE_EMAIL: 'UPDATE_EMAIL',
	SET_HUBSPOT_CONTACT_ID: 'SET_HUBSPOT_CONTACT_ID',
	UPDATE_PHONE: 'UPDATE_PHONE',
	UPDATE_REFERRAL_SOURCE: 'UPDATE_REFERRAL_SOURCE',
} as const;

export type ContactInfoStepAction = keyof typeof ContactInfoStepActions;

export interface ContactInfoStepActionPayload {
	[ContactInfoStepActions.UPDATE_FIRST_NAME]: string;
	[ContactInfoStepActions.UPDATE_LAST_NAME]: string;
	[ContactInfoStepActions.UPDATE_EMAIL]: string;
	[ContactInfoStepActions.SET_HUBSPOT_CONTACT_ID]: string;
	[ContactInfoStepActions.UPDATE_PHONE]: string;
	[ContactInfoStepActions.UPDATE_REFERRAL_SOURCE]: string;
}

export type ContactInfoStepActionMap =
	ActionMap<ContactInfoStepActionPayload>[keyof ActionMap<ContactInfoStepActionPayload>];

export const isContactInfoStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is ContactInfoStepActionMap => action.type in ContactInfoStepActions;

export const contactInfoStepReducer = (
	state: ReplaceVirtuallyFormState,
	action: ContactInfoStepActionMap,
): ReplaceVirtuallyFormState => {
	const [, updateProfile] = userProfile();

	switch (action.type) {
		case ContactInfoStepActions.UPDATE_FIRST_NAME:
			updateProfile('firstName', action.payload);
			return {
				...state,
				firstName: action.payload,
			};
		case ContactInfoStepActions.UPDATE_LAST_NAME:
			updateProfile('lastName', action.payload);
			return {
				...state,
				lastName: action.payload,
			};
		case ContactInfoStepActions.UPDATE_EMAIL:
			updateProfile('email', action.payload);
			return {
				...state,
				email: action.payload,
			};
		case ContactInfoStepActions.SET_HUBSPOT_CONTACT_ID:
			updateProfile('contactId', action.payload);
			return {
				...state,
				hubspotContactId: action.payload,
			};
		case ContactInfoStepActions.UPDATE_PHONE:
			updateProfile('phone', action.payload);
			return {
				...state,
				phone: action.payload,
			};
		case ContactInfoStepActions.UPDATE_REFERRAL_SOURCE:
			return {
				...state,
				referralSource: action.payload,
			};
		default:
			return state;
	}
};

export const isValid = (
	state: ReplaceVirtuallyFormState,
	phoneRequired: boolean,
): boolean => {
	const { firstName, lastName, email, phone } = state;
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const isValidEmail = emailRegex.test(email);

	// Phone is valid if:
	// 1. It's not required and is empty, OR
	// 2. It's fully entered (length >= 14)
	const isPhoneEmpty = phone.length === 0;
	const isPhoneComplete = phone.length >= 14;
	const isValidPhone = (!phoneRequired && isPhoneEmpty) || isPhoneComplete;

	return !!firstName && !!lastName && !!email && isValidEmail && isValidPhone;
};
